<template>
    <div class="homecontainer container-fluid no-gutters w-container">
        <!-- 头部图片 -->

        <div class="row row-grid align-items-center">
            <div class="text-center">
                <!-- Image -->
                <figure class="w-100">
                    <img alt="Image placeholder" src="../assets/img/introduction/img-top.jpg" class="top-img">
                </figure>
            </div>
        </div>

        <div class="row justify-content-center">
            <!-- 简介内容 -->
            <div class="content-container">

                <p class="content-title">园区简介</p>

                <div class="content-one">
                    <div>
                        <p class="content-one-text">
                            “大洲玉文化创意园”由北京大洲文化传播有限公司联合多位中国工艺美术大师、非趟传承人和新锐玉雕艺术工作者等有识之士共同发起建立,以原创玉雕艺术和时尚珠宝设计为核心,传承和弘扬民族文化的精髓,打造以玉文化为主题的创新发展型艺术园区。
                        </p>
                        <p class="content-one-text">玉,汲天地之灵气(,温润面泽,卓不群..….….“大洲玉”品牌源自千字文中“金生丽水,玉出昆冈”一说,古之昆仑,谓之大洲,故名之。</p>
                        <p class="content-one-text">
                            2019年由行业协会专家和多位中国工艺美术大师等14名专家学齐组建的大洲玉文化创意网专家委员会成立,意在共同推动玉文化创意产业集群的建立和发展,挖掘中华文化底蕴,诠释玉文化肉酒,讲好中国文化故事。
                        </p>
                    </div>
                    <img src="../assets/img/introduction/content-one.jpg" alt="" class="content-one-img">
                </div>

                <div class="content-two">
                    <img src="../assets/img/introduction/content-two.jpg" alt="" class="content-two-img">
                    <div>
                        <p class="content-two-text">
                            “大洲王文化创意园”自成立以来始终紧密围绕国家关于文化和艺术发展的重要细要,以传承创新中国优秀文化、提升中国文化国际影响力为已任,立足北京,着眼全国,连通世界。这样一个以玉为主题的文化创意园区,不仅丰富了宋庄文化创意聚集区的艺术门类,也是北京工艺美术行业探索发展的试验田。用时向和创意诠释玉的文化内涵,讲好中国文化故事,服务北京建设全国文化中心,为中国优秀传统文化“走出去"献力。
                        </p>
                        <p class="content-two-text">
                            “大洲玉文化创意园”位于通州区宋庄镇北寺村北口,占地面积两万余平。同区所处地理位置空气极佳,网区装修更是巧夺天工,即保留了原厂区一些经典大型的工业设备,又添加了一些时尚元素,结合园区绿化,环境优美,观别致,具一格。现园区边围共有九栋联排别墅工作室,同区主楼共三层,一层与二层现有十余家大师工作室入驻,三层为博艺画帘精品校区
                        </p>
                    </div>

                </div>


                <div class="content-three">
                    <div>
                        <p class="content-three-text">
                            ,我园区主楼还配有专业展厅,展厅共设有两层,配有专业LED舞台,及其音响设备,可承接各类大型高端活动与会议。园区内设2000平米的艺术展厅,分为四个独立的展陈空,展厅外设有多个独立艺术家工作室,主楼6000平米玉雕工作室、原创设计空间,同时引进高品质咖啡厅、特色餐厅和健身房等配套服务,安防设施完善停车方便,欢迎您的到来
                        </p>
                        <p class="content-three-text">
                            “大洲玉文化创意园”由北京大洲文化传播有限公司联合多位非遗传承人、高级工艺美术师、资深艺术工作者共同发起建设,以原创玉雕艺术和时尚珠宝设计为内核的玉雕艺术创新发展型园区。自成立以来始终紧密围绕国家关于文化和艺术发展的重要纲要，以传承创新中国优秀文化、提升中国文化国际影响力为已任,立足北京,着眼全国,连通世界。大洲玉文化创意园,致力于打造产、学、研、为一体的工艺传承、创意创造与国际交流平台,不断创新传播方法、拓展传播渠道,讲好中国文化故事,服务北京建设全国文化中心和国际玉文化交流中心，不断为发扬中国优秀传统文化贡献自己的力最。
                        </p>

                    </div>
                    <img src="../assets/img/introduction/content-three.jpg" alt="" class="content-one-img">
                </div>
            </div>

            <!-- 园区企业 -->
            <div class="bottom-container">

                <p class="bottom-title">园区企业</p>
                <div class="botoom-img-container">
                    <img src="../assets/img/introduction/bottom-one.jpg" alt="" class="bottom-img">
                    <img src="../assets/img/introduction/bottom-two.jpg" alt="" class="bottom-img">
                    <img src="../assets/img/introduction/bottom-three.jpg" alt="" class="bottom-img">
                    <img src="../assets/img/introduction/bottom-four.jpg" alt="" class="bottom-img">
                    <img src="../assets/img/introduction/bottom-five.jpg" alt="" class="bottom-img">
                </div>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: 'Introduction',
    data() {
        return {

        }
    },
}
</script>

<style lang="less">
.title-container {
    background-color: #ffffff;

}

.w-100 {
    width: 100% !important;
}

.top-img {
    max-width: 100%;
    height: auto;
    // display: block;
    // position: absolute;
}

.content-container {
    background-color: #ffffff;
    margin-top: 50px;
    max-width: 1400px;
}

.content-title {
    width: 100%;
    height: auto;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
}

.content-one {
    margin-left: 10%;
    display: flex;
}

.content-one-text {
    font-weight: bold;
    text-indent: 2em
}

.content-one-img {
    width: 150px;
    height: 200px;
    margin-right: 10%;
    margin-left: 50px;
}

.content-two {
    margin-left: 10%;
    display: flex;
}

.content-two-img {
    width: 150px;
    height: 200px;
    margin-right: 50px;
    margin-top: 20px;

}

.content-two-text {
    font-weight: bold;
    text-indent: 2em;
    margin-right: 10%;
    margin-top: 20px;
}

.content-three {
    margin-left: 10%;
    display: flex;
    margin-top: 20px
}

.content-three-text {
    font-weight: bold;

}

.content-three-img {
    width: 150px;
    height: 200px;
    margin-right: 10%;
    margin-left: 50px;
}

.bottom-container {
    width: 100%;
    height: auto;
    background-color: #f7f8fa;
    margin-top: 20px;

}

.bottom-title {
    width: 100%;
    height: auto;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
    padding-top: 30px;
}

.botoom-img-container {
    display: flex;
    justify-content: center;
}

.bottom-img {
    width: 10%;
    max-width: 130px;
    height: auto;
    margin: 30px;
}</style>